import React from "react";

function Forgotpassword() {
  return (
    <>
      <div className="container-fluid">
        <div className="authentication-main">
          <div className="row">
            <div className="col-md-12 p-0">
              <div className="auth-innerright">
                <div className="authentication-box">
                  <div className="text-center">
                    <img src="../assets/images/endless-logo.png" alt="" />
                  </div>
                  <div className="card mt-4 p-4 mb-0">
                    <form className="theme-form">
                      <div className="mb-3">
                        <label className="col-form-label">
                          Enter your email
                        </label>
                        <input
                          className="form-control"
                          type="password"
                          placeholder="*******"
                        />
                      </div>
                      <div className="form-row mb-2">
                        <div className="col-md-3">
                          <button className="btn btn-primary" type="submit">
                            Request
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Forgotpassword;
